<default-facet *ngIf="customer !== 'richemont' && customer !== 'heraeus'" [facet]="facet" [previewImageUrl]="previewImageUrl"  />
<richemont-facet *ngIf="customer === 'richemont'" [facet]="facet" [previewImageUrl]="previewImageUrl"  />
<heraeus-facet *ngIf="customer === 'heraeus'" [facet]="facet" [previewImageUrl]="previewImageUrl"  />
